export default "<birds-eye [job-id]=\"jobId\" [job-instance]=\"jobInstance\" [close-callback]=\"closeCallback\"></birds-eye>\n";